// In ActionHandler.js
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../../firebase';

function ActionHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function handleAction() {
      const mode = searchParams.get('mode');
      const actionCode = searchParams.get('oobCode');
      
      console.log('ActionHandler: Processing', mode);
      
      if (!mode || !actionCode) {
        // Invalid parameters, redirect to dashboard
        navigate('/dashboard');
        return;
      }

      try {
        if (mode === 'verifyEmail') {
          try {
            // Try to verify the email
            await applyActionCode(auth, actionCode);
            console.log('Verification successful');

            // Add this code here to reload the user
        if (auth.currentUser) {
        await auth.currentUser.reload();
        }
            
            // Redirect to dashboard with success parameter
            navigate('/dashboard?emailVerified=success');
          } catch (error) {
            console.error('Verification error:', error);
            
            // Even if verification "fails", it might be because it was already verified
            // or the code was used - so check if the user is logged in
            if (auth.currentUser) {
              // If user is logged in, just send them to dashboard
              navigate('/dashboard');
            } else {
              // If no user is logged in, send to login with a message
              navigate('/login?message=verification-complete');
            }
          }
        } else if (mode === 'resetPassword') {
          // For password reset, redirect to a password reset page
          navigate(`/reset-password?oobCode=${actionCode}`);
        } else {
          // Unsupported action, redirect to dashboard
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Action handling error:', error);
        // If anything goes wrong, redirect to dashboard
        navigate('/dashboard');
      }
    }

    handleAction();
  }, [searchParams, navigate]);

  // Show a minimal loading indicator only
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Processing...</h2>
        <p>Please wait while we verify your email.</p>
      </div>
    </div>
  );
}

export default ActionHandler;